import { push } from 'connected-react-router';
import { NavigationItem, NavigationLink, NavigationGroup } from '@css-xp/graphtypes';

// Wrapper functions for navigating with table row clicks, allows user to grab selection without changing pages

export const navigateTo = (url: string) => {
  const selection = window.getSelection();

  if (!selection || !selection.toString()) {
    return push(url);
  } else {
    return {
      type: 'NOOP',
    };
  }
};

export const isNavigationLink = (item: NavigationItem): item is NavigationLink => {
  return (item as NavigationLink).url !== undefined;
};

export const isNavigationGroup = (item: NavigationItem): item is NavigationGroup => {
  return (item as NavigationGroup).links !== undefined;
};
